<template>
    <el-form ref="ruleform" :model="form" :rules="rules" :label-width="this.$store.state.labelWidth" size="small">
        <el-form-item :label="$t('novelist.booktitle')" prop="title">
            <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item :label="$t('novelist.cover')" prop="coverpic">
            <el-upload
                    class="avatar-uploader"
                    action="upDataUrl"
                    :show-file-list="false"
                    :http-request="myUpload1"
                    :before-upload="beforeAvatarUpload">
                <el-image v-if="form.coverpic" :src="form.coverpic" class="conver_pic" fit="fill"></el-image>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="input_hint" v-html="$t('_input_holder_cover')"></div>
        </el-form-item>
        <el-form-item :label="$t('novelist.desc')" prop="desc">
            <el-input v-model="form.desc" :autosize="{ minRows: 4}" type="textarea"></el-input>
        </el-form-item>
        <el-form-item :label="$t('novelist.columns')" v-if="show_cloums">
            <el-cascader
                    v-model="form.areaIds"
                    :options="areaIds"
                    :props="{multiple: true}"
                    clearable
                    style="width: 100%">
            </el-cascader>
        </el-form-item>

        <el-form-item :label="$t('books.classification')" prop="cateids">
            <el-checkbox-group v-model="form.cateids">
                <el-checkbox :label="item.id" v-for="item in classList">{{item.name}}</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item :label="$t('books.age_classification')" prop="age_limit">
            <el-radio-group v-model="form.age_limit">
                <el-radio :label="1">10+</el-radio>
                <el-radio :label="2">13+</el-radio>
                <el-radio :label="3">17+</el-radio>
                <el-radio :label="4">18+</el-radio>
            </el-radio-group>
            <br>
            <span class="input_hint">{{$t('_input_holder_age')}}</span>
        </el-form-item>
        <el-form-item :label="$t('_gender')" prop="issex">
            <el-select v-model="form.issex" placeholder="">
                <el-option :label="$t('_male')" :value="1"></el-option>
                <el-option :label="$t('_female')" :value="2"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('novelist.finished_status')" v-if="show_wz" prop="iswz">
            <el-select v-model="form.iswz" placeholder="">
                <el-option :label="$t('books.serial')" :value="1"></el-option>
                <el-option :label="$t('books.finished')" :value="2"></el-option>
            </el-select>
        </el-form-item>
    </el-form>
</template>

<script>
    import i18n from "../../utils/i18n";
    import {uploadCoverimg, uploadimg} from "../../utils/common";

    export default {
        name: "novel_detail_component",
        props:{
            form:{
                type: Object,
                default: {
                    title: '',
                    author: '',
                    infopic: '',
                    coverpic: '',
                    selectpic: '',
                    cateids: [],
                    columnids: [],
                    isfw: '',
                    isnew: '',
                    islong: '',
                    issex: 1,
                    tag: '',
                    iswz: 1,
                    isbg: '',
                    remark: '',
                    list_order: '',
                    desc: '',
                    paychapter: '',
                    thermal: '',
                    hots: '',
                    likes: '',
                    sharetitle: '',
                    sharedesc: '',
                    tchapter: '',
                    coin: '',
                    isrecommend: '',
                    ishow: '',
                    status: '',
                    laguage_type: i18n.locale=='en_US'?2:1,
                }
            },
            show_wz:{
                type:Boolean,
                default: false,
            },
            show_cloums:{
                type:Boolean,
                default: false,
            }
        },
        data() {
            return {
                classList: [],
                areaIds: [],
                rules: {
                    title: [
                        { required: true, message: this.$i18n.t('_required_book_title'), trigger: 'blur' }
                    ],
                    /**
                     *   coverpic: [
                     { required: true, message: this.$i18n.t('_required_book_coverpic'), trigger: 'blur',validator:this.imgValidator  }
                     ],
                     */
                    desc: [
                        { required: true, message: this.$i18n.t('_required_book_desc'), trigger: 'blur' }
                    ],
                    cateids: [
                        { required: true, message: this.$i18n.t('_required_book_cateids'), trigger: 'change',},
                    ],
                    age_limit: [
                        { required: true, message: this.$i18n.t('_required_book_age_limit'), trigger: 'change' }
                    ],
                    issex: [
                        { required: true, message: this.$i18n.t('_required_book_sex'), trigger: 'change' }
                    ],
                    iswz: [
                        { required: true, message: this.$i18n.t('_required_book_iswz'), trigger: 'change' }
                    ]
                },
            }
        },

        created() {
            this.getCateIds();
            this.getAreaIds();
        },
        methods: {
            imgValidator(rule, value, callback) {
                if (!this.form.id_card_front) {
                    callback(new Error('can not be null'))
                } else {
                    callback();
                }
            },
            onSubmit() {
                this.$refs['ruleform'].validate((valid) => {
                    if (valid) {
                        this.onSubmitHandle()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            onSubmitHandle() {
                let params = {...this.form}
                // dispatchEvent
                this.$emit("submitEvent", params);
            },
            getCateIds() {
                this.$axios.post("writer/novel/category").then((res) => {
                    this.classList = res.data;
                });
            },
            getAreaIds() {
                this.$axios.post("writer/novel/column").then((res) => {
                    this.areaIds = res.data;
                });
            },
            myUpload1(content) {
              uploadCoverimg(content).then(res => {
                    this.form.coverpic = res;
                })
            },

            beforeAvatarUpload(file) {
                var suffix = file.name.substring(file.name.lastIndexOf('.') + 1);
                let arr = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf', 'JPG', 'JPEG', 'PNG', 'GIF', 'BMP', 'PDF']
                if (arr.indexOf(suffix) === -1) {
                    this.$message.error(this.$i18n.t('_upload_format_err'));
                    return false
                }
                if (file.size > (1024 * 1024)) {
                    this.$message.error(this.$i18n.t('_upload_size_err'));
                    return false;
                }

                return new Promise((resolve, reject) => {
                    var Max_Width = 450;
                    var Max_Height = 600;
                    var reader = new FileReader();
                    reader.onload = (e) => {
                        var data = e.target.result;
                        var image = new Image();
                        image.onload = () => {
                            var width = image.width;
                            var height = image.height;
                            var isAllow =false ;//width != Max_Width || height != Max_Height;
                            if (isAllow) {
                                this.$message.error(this.$i18n.t('_upload_widhigh_err'));
                                reject();
                            } else {
                                resolve();
                            }
                        };
                        image.src = data;
                    };
                    reader.readAsDataURL(file);
                });
            },

            html_decode(str) {
                var s = "";
                if (str.length == 0) return "";
                s = str.replace(/&amp;/g, "&");
                s = s.replace(/&lt;/g, "<");
                s = s.replace(/&gt;/g, ">");
                s = s.replace(/&nbsp;/g, " ");
                s = s.replace(/&#39;/g, "\'");
                s = s.replace(/&quot;/g, "\"");
                s = s.replace(/<br\/>/g, "\n");
                return s;
            },
        }
    }
</script>

<style scoped>

</style>